import { Components } from "@mui/material";


export const components: Components = {
  MuiSkeleton: { defaultProps: { animation: "wave" } },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: false,
      style: {
        textTransform: "initial",
        // boxShadow: `none`,
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none'
      }
    }
  },

  MuiUseMediaQuery: {
    defaultProps: {
      noSsr: true,
    },
  },
};

